import React from 'react';
import { Button } from 'primereact/button';
import { ToggleButton } from 'primereact/togglebutton';
import { Avatar } from 'primereact/avatar';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import Stats from './Stats';
import SJBanner from '../snp/SJBanner';

const LandingPage = () => {
  return (
    <div className="block-content ">
      {/* Hot Deals Banner */}
      {/* <div className="bg-bluegray-900 text-gray-100 p-3 flex justify-content-between lg:justify-content-center align-items-center flex-wrap">
        <div className="font-bold mr-8">🔥 Hot Deals!</div>
        <div className="align-items-center hidden lg:flex">
          <span className="line-height-3">Libero voluptatum atque exercitationem praesentium provident odit.</span>
        </div>
        <a className="flex align-items-center ml-2 mr-8">
          <span className="underline font-bold">Learn More</span>
        </a>
        <a className="flex align-items-center no-underline justify-content-center border-circle text-gray-100 hover:bg-bluegray-700 cursor-pointer transition-colors transition-duration-150" style={{ width: '2rem', height: '2rem' }}>
          <i className="pi pi-times"></i>
        </a>
      </div> */}

      {/* Navbar */}
      {/* <div className="surface-overlay py-3 px-6 shadow-2 flex align-items-center justify-content-between relative lg:static">
        <img src="/images/blocks/logos/hyper.svg" alt="Image" height="50" />
        <a className="cursor-pointer block lg:hidden text-700">
          <i className="pi pi-bars text-4xl"></i>
        </a>
        <div className="align-items-center flex-grow-1 justify-content-between hidden lg:flex absolute lg:static w-full surface-overlay left-0 top-100 px-6 lg:px-0 z-2 shadow-2 lg:shadow-none">
          <section></section>
          <ul className="list-none p-0 m-0 flex lg:align-items-center text-900 select-none flex-column lg:flex-row cursor-pointer">
            <li className="relative">
              <a className="flex px-0 lg:px-5 py-3 align-items-center hover:text-blue-600 font-medium transition-colors transition-duration-150">
                <span>Products</span>
                <i className="pi pi-chevron-down ml-auto lg:ml-3"></i>
              </a>
              <ul className="list-none p-0 m-0 border-round shadow-0 lg:shadow-2 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem">
                <li>
                  <a className="flex p-3 align-items-center hover:surface-50 transition-colors transition-duration-150">
                    <i className="pi pi-list text-2xl mr-2 text-blue-600"></i>
                    <span>Features</span>
                  </a>
                </li>
                <li>
                  <a className="flex p-3 align-items-center hover:surface-50 transition-colors transition-duration-150">
                    <i className="pi pi-shield text-2xl mr-2 text-blue-600"></i>
                    <span>Solutions</span>
                  </a>
                </li>
                <li>
                  <a className="flex p-3 align-items-center hover:surface-50 transition-colors transition-duration-150">
                    <i className="pi pi-users text-2xl mr-2 text-blue-600"></i>
                    <span>Customers</span>
                  </a>
                </li>
                <li className="relative">
                  <a className="flex p-3 align-items-center hover:surface-50 transition-colors transition-duration-150">
                    <i className="pi pi-question-circle text-2xl mr-2 text-blue-600"></i>
                    <span>Support</span>
                    <i className="pi pi-chevron-down ml-auto lg:-rotate-90"></i>
                  </a>
                  <ul className="list-none py-3 pl-3 pr-0 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0">
                    <li>
                      <a className="flex p-3 align-items-center hover:surface-50 transition-colors transition-duration-150">
                        <i className="pi pi-cloud mr-2"></i>
                        <span className="font-medium">Help Center</span>
                      </a>
                    </li>
                    <li className="relative">
                      <a className="flex p-3 align-items-center hover:surface-50 transition-colors transition-duration-150">
                        <i className="pi pi-question-circle mr-2"></i>
                        <span className="font-medium">Faq</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <a className="flex px-0 lg:px-5 py-3 hover:text-blue-600 font-medium transition-colors transition-duration-150">
                <span>Corporate</span>
              </a>
            </li>
            <li>
              <a className="flex px-0 lg:px-5 py-3 hover:text-blue-600 font-medium transition-colors transition-duration-150">
                <span>Resources</span>
              </a>
            </li>
            <li>
              <a className="flex px-0 lg:px-5 py-3 hover:text-blue-600 font-medium transition-colors transition-duration-150">
                <span>Pricing</span>
              </a>
            </li>
          </ul>
          <div className="flex justify-content-between lg:block border-top-1 lg:border-top-none surface-border py-3 lg:py-0 mt-3 lg:mt-0">
            <Button label="Login" className="p-button-text font-bold" />
            <Button label="Register" className="p-button-outlined font-bold ml-3" />
          </div>
        </div>
      </div> */}

      {/* Hero Section */}
      {/* <div className="relative p-6 overflow-hidden px-6">
        <img src="/1.jpg" className="absolute top-0 left-0 w-auto h-full block md:w-full" alt="Image" />
        <div className="text-center my-6 relative">
          <div className="text-6xl text-white font-bold mb-1">The Platform For</div>
          <div className="text-6xl text-primary font-bold mb-4">Today's Generation</div>
          <p className="mt-0 mb-4 line-height-3 text-center mx-auto text-white" style={{ maxWidth: '500px' }}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
          <Button label="Learn More" className="mb-4" />

          <p className="text-sm mt-4 mb-4 line-height-3 text-white">Available for MacOS, Web and Google accounts only</p>
          <div className="flex justify-content-center align-items-center">
            <a href="https://www.apple.com" className="text-white mr-3">
              <i className="pi pi-apple text-2xl"></i>
            </a>
            <a href="https://play.google.com" className="text-white mr-3">
              <i className="pi pi-android text-2xl"></i>
            </a>
            <a href="https://www.facebook.com" className="text-white">
              <i className="pi pi-facebook text-2xl"></i>
            </a>
          </div>
        </div>
      </div> */}
      <SJBanner />
      {/* <Stats/> */}

      {/* Features Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8">
        <div className="text-center">
          <div className="mb-3 font-bold text-4xl">
            <span className="text-primary">Why </span>
            <span className="text-yellow-500"> Finvisors</span>
          </div>
          <div className="text-700 text-sm mb-6">
            Discover how we simplify your finances and empower your growth.
          </div>
          <div className="grid">
            <div className="col-12 md:col-4 mb-4 px-5">
              <span className="p-3 shadow-2 mb-3 inline-block" style={{ borderRadius: '10px' }}>
                <i className="pi pi-cog text-4xl text-primary"></i>
              </span>
              <div className="text-primary mb-3 font-medium">Innovative Workflow</div>
              <span className="text-700 text-sm line-height-3">
                We use cutting-edge tech and best practices to streamline your reporting with precision and speed.
              </span>
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <span className="p-3 shadow-2 mb-3 inline-block" style={{ borderRadius: '10px' }}>
                <i className="pi pi-shield text-4xl text-primary"></i>
              </span>
              <div className="text-primary mb-3 font-medium">100% Data Security</div>
              <span className="text-700 text-sm line-height-3">
                Your financial data is protected with enterprise-grade security measures.
              </span>
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <span className="p-3 shadow-2 mb-3 inline-block" style={{ borderRadius: '10px' }}>
                <i className="pi pi-comments text-4xl text-primary"></i>
              </span>
              <div className="text-primary mb-3 font-medium">Seamless Collaboration</div>
              <span className="text-700 text-sm line-height-3">
                We're always a call away — aligned with your team for clarity and speed.
              </span>
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <span className="p-3 shadow-2 mb-3 inline-block" style={{ borderRadius: '10px' }}>
                <i className="pi pi-forward text-4xl text-primary"></i>
              </span>
              <div className="text-primary mb-3 font-medium">3x Faster Onboarding</div>
              <span className="text-700 text-sm line-height-3">
                Get started quickly with our proven onboarding system that saves time and hassle.
              </span>
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <span className="p-3 shadow-2 mb-3 inline-block" style={{ borderRadius: '10px' }}>
                <i className="pi pi-briefcase text-4xl text-primary"></i>
              </span>
              <div className="text-primary mb-3 font-medium">Decade of Experience</div>
              <span className="text-700 text-sm line-height-3">
                10+ years helping businesses manage their books with clarity and confidence.
              </span>
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <span className="p-3 shadow-2 mb-3 inline-block" style={{ borderRadius: '10px' }}>
                <i className="pi pi-users text-4xl text-primary"></i>
              </span>
              <div className="text-primary mb-3 font-medium">Dedicated Experts</div>
              <span className="text-700 text-sm line-height-3">
                Work with certified accountants and analysts committed to your success.
              </span>
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <span className="p-3 shadow-2 mb-3 inline-block" style={{ borderRadius: '10px' }}>
                <i className="pi pi-chart-line text-4xl text-primary"></i>
              </span>
              <div className="text-primary mb-3 font-medium">Real-Time Insights</div>
              <span className="text-700 text-sm line-height-3">
                Access up-to-date dashboards and reports that power smarter decisions.
              </span>
            </div>
            <div className="col-12 md:col-4 md:mb-4 mb-0 px-5">
              <span className="p-3 shadow-2 mb-3 inline-block" style={{ borderRadius: '10px' }}>
                <i className="pi pi-wallet text-4xl text-primary"></i>
              </span>
              <div className="text-primary mb-3 font-medium">Cost Savings</div>
              <span className="text-700 text-sm line-height-3">
                Reduce overheads with flexible plans — no hiring, training, or infra costs.
              </span>
            </div>
          </div>
        </div>
      </div>


      {/* CTA Section */}
      {/* <div className="surface-section px-4 pb-8 md:px-6 lg:px-8">
        <div className="p-6 shadow-2 flex flex-column md:flex-row align-items-center justify-content-between" style={{ borderRadius: '1rem', background: 'linear-gradient(0deg, rgba(0, 123, 255, 0.5), rgba(0, 123, 255, 0.5)), linear-gradient(92.54deg, #1C80CF 47.88%, #FFFFFF 100.01%)' }}>
          <div className="pr-6">
            <div className="text-primary font-medium text-xl mb-3">TAKE THE NEXT STEP</div>
            <div className="text-white font-medium text-5xl">Empower your customer experience</div>
          </div>
          <div className="mt-4 mr-auto md:mt-0 md:mr-0">
            <Button label="Get Started" className="p-button-warning font-bold px-3 py-2 rounded-button white-space-nowrap p-button-raised" />
          </div>
        </div>
      </div> */}

      {/* Stats Section */}
      {/* <div className="surface-ground px-4 py-8 md:px-6 lg:px-8">
        <div>
          <div className="text-900 font-bold text-4xl line-height-3 mb-3 text-center">Continue Breaking Records</div>
          <p className="text-600 line-height-3 text-lg m-0 mb-6 text-center">
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
          </p>

          <div className="grid surface-card shadow-2" style={{ borderRadius: '10px' }}>
            <div className="col-12 md:col-3 px-5 py-5">
              <i className="pi pi-users text-4xl text-blue-600 mb-3"></i>
              <div className="text-900 font-bold text-4xl mb-3 line-height-3">83M</div>
              <p className="text-700 m-0">Nostrum laborum accusamus quia iste facere possimus.</p>
            </div>
            <div className="col-12 md:col-3 px-5 py-5">
              <i className="pi pi-chart-line text-4xl text-orange-500 mb-3"></i>
              <div className="text-900 font-bold text-4xl mb-3 line-height-3">$256K</div>
              <p className="text-700 m-0">Nostrum laborum accusamus quia iste facere possimus.</p>
            </div>
            <div className="col-12 md:col-3 px-5 py-5">
              <i className="pi pi-globe text-4xl text-cyan-600 mb-3"></i>
              <div className="text-900 font-bold text-4xl mb-3 line-height-3">1,453</div>
              <p className="text-700 m-0">Nostrum laborum accusamus quia iste facere possimus.</p>
            </div>
            <div className="col-12 md:col-3 px-5 py-5">
              <i className="pi pi-map text-4xl text-purple-500 mb-3"></i>
              <div className="text-900 font-bold text-4xl mb-3 line-height-3">45 km</div>
              <p className="text-700 m-0">Nostrum laborum accusamus quia iste facere possimus.</p>
            </div>
          </div>
        </div>
      </div> */}

      {/* Clients Section */}
      {/* <div className="surface-section px-4 py-8 md:px-6 lg:px-8">
        <div>
          <div className="text-900 mb-3 font-bold text-4xl text-center">Trusted By</div>
          <div className="text-600 mb-6 line-height-3 text-xl text-center">
            We provide many of the Planet Earth's most powerful companies with extraordinary infrastructural capabilities.
          </div>

          <div className="grid">
            <div className="col-12 md:col-6 lg:col-3">
              <div className="flex align-items-center justify-content-center p-3">
                <img src="/images/blocks/logos/alfred-500.svg" alt="Image" />
              </div>
            </div>
            <div className="col-12 md:col-6 lg:col-3">
              <div className="flex align-items-center justify-content-center p-3">
                <img src="/images/blocks/logos/hyper-500.svg" alt="Image" />
              </div>
            </div>
            <div className="col-12 md:col-6 lg:col-3">
              <div className="flex align-items-center justify-content-center p-3">
                <img src="/images/blocks/logos/bastion-500.svg" alt="Image" />
              </div>
            </div>
            <div className="col-12 md:col-6 lg:col-3">
              <div className="flex align-items-center justify-content-center p-3">
                <img src="/images/blocks/logos/peak-500.svg" alt="Image" />
              </div>
            </div>
            <div className="col-12 md:col-6 lg:col-3">
              <div className="flex align-items-center justify-content-center p-3">
                <img src="/images/blocks/logos/charot-500.svg" alt="Image" />
              </div>
            </div>
            <div className="col-12 md:col-6 lg:col-3">
              <div className="flex align-items-center justify-content-center p-3">
                <img src="/images/blocks/logos/shodan-500.svg" alt="Image" />
              </div>
            </div>
            <div className="col-12 md:col-6 lg:col-3">
              <div className="flex align-items-center justify-content-center p-3">
                <img src="/images/blocks/logos/hodly-500.svg" alt="Image" />
              </div>
            </div>
            <div className="col-12 md:col-6 lg:col-3">
              <div className="flex align-items-center justify-content-center p-3">
                <img src="/images/blocks/logos/franki-500.svg" alt="Image" />
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="surface-ground px-4 py-8 md:px-6 lg:px-8">
  <div>
    <div className="font-bold text-4xl text-900 mb-5 text-center">Featured Articles</div>
    <div className="grid nogutter">
      
      <div className="col-12 lg:col-4 p-3">
        <div className="shadow-2 border-round h-full surface-card">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcuVNaxg1pmbRvWjRcCuDEA51s5b2-BGe8eQ&s"
            className="block w-full border-round-top"
            alt="Cloud Accounting"
          />
          <div className="p-4">
            <span className="block font-medium text-blue-600 mb-3">Accounting</span>
            <div className="text-xl text-900 font-medium mb-3 line-height-3">
              How Cloud Accounting Transforms Global SMEs
            </div>
            <div className="text-sm line-height-3 mb-3 text-700">
              Discover why cloud-based bookkeeping is the future for businesses across Australia, the UK, USA and India—and how to get started.
            </div>
            <div className="flex">
              <Avatar image="/images/blocks/avatars/circle/avatar-m-1.png" shape="circle" />
              <div className="ml-2">
                <div className="text-xs font-bold text-900 mb-1">Rajesh Kumar</div>
                <div className="text-xs flex align-items-center text-700">
                  <i className="pi pi-calendar mr-1 text-xs"></i>
                  <span>Jun 1, 2025</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 lg:col-4 p-3">
        <div className="shadow-2 border-round h-full surface-card">
          <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQuFN5E5R2H0_A4I-M27NYoNtATB-rqEXxIIQ&s"

            className="block w-full border-round-top"
            alt="Top Accounting Tools"
          />
          <div className="p-4 flex flex-column">
            <span className="block font-medium text-blue-600 mb-3">Technology</span>
            <div className="text-xl text-900 font-medium mb-3 line-height-3">
              Top 5 Accounting Tools We Excel In
            </div>
            <div className="text-sm line-height-3 mb-3 text-700">
              An insider’s guide to the 20+ platforms we master—so you can choose the perfect fit for your bookkeeping needs.
            </div>
            <div className="flex">
              <Avatar image="/images/blocks/avatars/circle/avatar-f-4.png" shape="circle" />
              <div className="ml-2">
                <div className="text-xs font-bold text-900 mb-1">Priya Patel</div>
                <div className="text-xs flex align-items-center text-700">
                  <i className="pi pi-calendar mr-1 text-xs"></i>
                  <span>May 20, 2025</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 lg:col-4 p-3">
        <div className="shadow-2 border-round h-full surface-card">
          <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQY8ImrVug6W0LAQCWlYTAtrXauxhL5uTDtOA&s"
            className="block w-full border-round-top"
            alt="Global Payroll"
          />
          <div className="p-4">
            <span className="block font-medium text-blue-600 mb-3">Payroll &amp; Tax</span>
            <div className="text-xl text-900 font-medium mb-3 line-height-3">
              Navigating Global Payroll: Best Practices
            </div>
            <div className="text-sm line-height-3 mb-3 text-700">
              From compliance in the USA to TDS in India—learn how our experts handle multi-country payroll seamlessly.
            </div>
            <div className="flex">
              <Avatar image="/images/blocks/avatars/circle/avatar-m-2.png" shape="circle" />
              <div className="ml-2">
                <div className="text-xs font-bold text-900 mb-1">Michael Smith</div>
                <div className="text-xs flex align-items-center text-700">
                  <i className="pi pi-calendar mr-1 text-xs"></i>
                  <span>May 12, 2025</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div> */}


      {/* Pricing Section */}
      {/* <div className="surface-section px-4 py-8 md:px-6 lg:px-8">
        <div>
          <div className="text-blue-600 text-2xl mb-4 text-center">Save up to 25% today</div>
          <div className="text-900 font-bold text-4xl text-center mb-4">Pricing Plans</div>
          <div className="flex align-items-center justify-content-center text-900">
            <span className="font-semibold mr-3">Monthly</span>
            <ToggleButton checked={false} onChange={() => {}} />
            <span className="ml-3">Yearly</span>
          </div>

          <div className="flex flex-column md:flex-row mt-6">
            <div className="mb-6 md:mb-0 mr-0 md:mr-4 flex flex-column flex-grow-1">
              <div className="bg-bluegray-100 text-center p-3" style={{ borderRadius: '6px 6px 0 0' }}>
                <div className="text-2xl font-bold text-bluegray-900 mb-3">Basic</div>
                <div className="flex align-items-center justify-content-center">
                  <span className="font-bold text-bluegray-900 text-5xl mr-2">10$</span>
                  <span className="text-2xl text-bluegray-400"> / month</span>
                </div>
              </div>
              <div className="bg-bluegray-50 p-4 flex flex-column flex-grow-1" style={{ boxShadow: 'inset 0 2px 8px rgba(0, 0, 0, 0.1)', borderRadius: '0 0 6px 6px' }}>
                <div className="text-bluegray-500 font-bold line-height-3 mb-4">
                  Ut enim ad minim veniam, quis nostrud exercitation.
                </div>
                <ul className="list-none p-0 m-0 mb-5 text-bluegray-600">
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-circle-on mr-2 text-sm"></i>
                    <span>Arcu vitae elementum</span>
                  </li>
                  <li className="flex align-items-center">
                    <i className="pi pi-circle-on mr-2 text-sm"></i>
                    <span>Dui faucibus in ornare</span>
                  </li>
                </ul>
                <Button label="Try Free" className="p-button-secondary w-full mt-auto" />
              </div>
            </div>

            <div className="mb-6 md:mb-0 mr-0 md:mr-4 flex flex-column flex-grow-1">
              <div className="bg-bluegray-800 text-center p-3 border-3 border-green-500 border-bottom-none" style={{ borderRadius: '6px 6px 0 0' }}>
                <div className="bg-green-500 text-0 font-bold text-sm inline-block p-2 mb-3" style={{ borderRadius: '20px' }}>
                  MOST POPULAR
                </div>
                <div className="text-2xl font-bold text-white mb-3">Premium</div>
                <div className="flex align-items-center justify-content-center">
                  <span className="font-bold text-white text-5xl mr-2">20$</span>
                  <span className="text-2xl text-bluegray-400"> / month</span>
                </div>
              </div>
              <div className="bg-bluegray-900 p-4 flex flex-column flex-grow-1 border-3 border-green-500 border-top-none" style={{ boxShadow: 'inset 0 2px 8px rgba(0, 0, 0, 0.1)', borderRadius: '0 0 6px 6px' }}>
                <div className="text-bluegray-400 font-bold line-height-3 mb-4">
                  Ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </div>
                <ul className="list-none p-0 m-0 mb-5 text-bluegray-100">
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-circle-on mr-2 text-sm"></i>
                    <span>Arcu vitae elementum</span>
                  </li>
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-circle-on mr-2 text-sm"></i>
                    <span>Dui faucibus in ornare</span>
                  </li>
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-circle-on mr-2 text-sm"></i>
                    <span>Morbi tincidunt augue</span>
                  </li>
                  <li className="flex align-items-center">
                    <i className="pi pi-circle-on mr-2 text-sm"></i>
                    <span>Duis ultricies lacus sed</span>
                  </li>
                </ul>
                <Button label="Buy Now" className="p-button-success w-full mt-auto" />
              </div>
            </div>

            <div className="mb-6 md:mb-0 flex flex-column flex-grow-1">
              <div className="bg-blue-800 text-center p-3" style={{ borderRadius: '6px 6px 0 0' }}>
                <div className="text-2xl font-bold text-white mb-3">Enterprise</div>
                <div className="flex align-items-center justify-content-center">
                  <span className="font-bold text-white text-5xl mr-2">30$</span>
                  <span className="text-2xl text-blue-400"> / month</span>
                </div>
              </div>
              <div className="bg-blue-900 p-4 flex flex-column flex-grow-1" style={{ boxShadow: 'inset 0 2px 8px rgba(0, 0, 0, 0.1)', borderRadius: '0 0 6px 6px' }}>
                <div className="text-blue-400 font-bold line-height-3 mb-4">
                  Duis aute irure dolor in reprehenderit in voluptate velit.
                </div>
                <ul className="list-none p-0 m-0 mb-5 text-blue-100">
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-circle-on mr-2 text-sm"></i>
                    <span>Arcu vitae elementum</span>
                  </li>
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-circle-on mr-2 text-sm"></i>
                    <span>Dui faucibus in ornare</span>
                  </li>
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-circle-on mr-2 text-sm"></i>
                    <span>Morbi tincidunt augue</span>
                  </li>
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-circle-on mr-2 text-sm"></i>
                    <span>Duis ultricies lacus sed</span>
                  </li>
                  <li className="flex align-items-center mb-3">
                    <i className="pi pi-circle-on mr-2 text-sm"></i>
                    <span>Imperdiet proin</span>
                  </li>
                </ul>
                <Button label="Contact Us" className="p-button-outlined w-full mt-auto" />
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Contact Section */}
      <div className="surface-ground">
        <div className="grid grid-nogutter">
          {/* Left Side - Contact Info with Gradient Background */}
          {/* <div className="col-12 md:col-6 bg-gradient-to-br from-blue-600 to-purple-700 p-8 md:p-10 lg:p-12">
          <div className="text-primary text-3xl font-bold mb-6">Get in Touch</div>
          <div className="text-blue-900 line-height-3 mb-8 text-lg" style={{ maxWidth: '400px' }}>
            We'd love to hear from you! Whether you have questions about our services or just want to say hello, our team is ready to help.
          </div>
          
          <a className="inline-flex align-items-center text-primary font-bold no-underline cursor-pointer hover:text-blue-200 transition-colors duration-300 mb-8">
            <span className="mr-3 border-b border-white pb-1">View Address on Google Maps</span>
            <i className="pi pi-arrow-right"></i>
          </a>
          
          <ul className="list-none p-0 m-0 mt-8 text-white space-y-4">
            <li className="flex align-items-center">
              <div className="bg-white bg-opacity-20 p-3 rounded-full mr-4">
                <i className="pi pi-phone text-xl"></i>
              </div>
              <div>
                <div className="text-primary text-sm">Phone</div>
                <div className="font-medium text-primary text-lg">+1 (234) 567-8910</div>
              </div>
            </li>
            <li className="flex align-items-center">
              <div className="bg-white bg-opacity-20 p-3 rounded-full mr-4">
                <i className="pi pi-twitter  text-xl"></i>
              </div>
              <div>
                <div className="text-primary text-sm">Twitter</div>
                <div className="font-medium text-primary text-lg">@yourbusiness</div>
              </div>
            </li>
            <li className="flex align-items-center">
              <div className="bg-white bg-opacity-20 p-3 rounded-full mr-4">
                <i className="pi pi-envelope text-xl"></i>
              </div>
              <div>
                <div className="text-primary text-sm">Email</div>
                <div className="font-medium text-primary text-lg">contact@yourbusiness.com</div>
              </div>
            </li>
          </ul>
        </div> */}

          {/* Right Side - Contact Form */}
          {/* <div className="col-12 md:col-6 bg-white">
          <div className="fluid formgrid grid px-6 py-10 md:px-8 lg:px-10">
            <div className="text-3xl font-bold mb-2 text-gray-800">Send Us a Message</div>
            <p className="text-gray-600 mb-6">Fill out the form below and we'll get back to you soon.</p>
            
            <div className="field col-12 lg:col-6 p-float-label mb-5">
              <InputText id="firstname" className="p-3 border-1 border-300 hover:border-primary focus:border-primary" />
              <label htmlFor="firstname" className="text-gray-600">First Name</label>
            </div>
            <div className="field col-12 lg:col-6 p-float-label mb-5">
              <InputText id="lastname" className="p-3 border-1 border-300 hover:border-primary focus:border-primary" />
              <label htmlFor="lastname" className="text-gray-600">Last Name</label>
            </div>
            <div className="field col-12 mb-5">
              <span className="p-float-label">
                <InputText id="email" className="p-3 w-full border-1 border-300 hover:border-primary focus:border-primary" />
                <label htmlFor="email" className="text-gray-600">Email</label>
              </span>
            </div>
            <div className="field col-12 mb-5">
              <span className="p-float-label">
                <InputText id="phone" className="p-3 w-full border-1 border-300 hover:border-primary focus:border-primary" />
                <label htmlFor="phone" className="text-gray-600">Phone</label>
              </span>
            </div>
            <div className="field col-12 mb-6">
              <span className="p-float-label">
                <InputTextarea id="message" className="p-3 w-full border-1 border-300 hover:border-primary focus:border-primary" rows={4} />
                <label htmlFor="message" className="text-gray-600">Your Message</label>
              </span>
            </div>
            <div className="col-12">
              <Button 
                label="Send Message" 
                icon="pi pi-send" 
                className="p-button-primary p-button-raised px-6 py-3 text-lg" 
              />
            </div>
          </div>
        </div> */}
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-900 px-4 py-8 md:px-6 lg:px-8">
        <div className="bg-gray-900">
          <div className="grid">
            <div className="col-12 md:col-4 flex flex-wrap justify-content-start md:mb-0 mb-3  ">
              <img src="/snpfull.png" className="mr-3 bg-white" alt="footer sections" width="300" height="80" />
              {/* <div className="text-gray-300 font-bold text-5xl">SnP Finvisors</div> */}
            </div>
            <div className="col-12 md:col-4">

              <div className="text-white text-lg mb-4" style={{ maxWidth: '290px' }}>
                <i className="pi pi-map-marker p-1 mr-2"></i> G - Floor, Swathi Plaza,
                Shyam Karan Rd, Leelanagar,
                Ameerpet, Hyderabad,
                Telangana, 500016.
              </div>
              <div className="text-white mb-3">
                <i className="pi pi-phone p-1 mr-2"></i>+91-93923 34305
                +91-93923 58230
              </div>
              <div className="text-white mb-3">
                <i className="pi pi-inbox p-1 mr-2"></i>admin@snpfinvisors.com
              </div>
            </div>
            <div className="col-12 md:col-4 text-gray-200">
              <div className="text-white font-bold line-height-3 mb-3">Company</div>
              <a className="line-height-3 block cursor-pointer mb-2">About Us</a>
              <a className="line-height-3 block cursor-pointer mb-2">News</a>
              <a className="line-height-3 block cursor-pointer mb-2">Careers</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;